export const EXPERIENCES_HEADER = "Experiences";

export const UPDATE_CALENDAR_TEXT = "Choose Dates";

export const WHERE_TO = "Where to?";

export const CHANGE_CTA_TEXT = "Change";
export const CONTACT_INFORMATION = "Contact Information";
export const DATE = "Date";
export const START_TIME = "Start time";
export const TRAVELERS = "Travelers";
export const OPERATOR = "Operator";
export const TOTAL_NUM_TRAVELERS = (totalTravelers: number) =>
  `${totalTravelers} ${totalTravelers === 1 ? "Traveler" : "Travelers"}`;

export const TAXES_AND_FEES = "Taxes & Fees";
export const TAXES_AND_FEES_INCLUDED =
  "Price is inclusive of taxes. It also includes any fees that are covered as part of the booking.";
export const FREE_CANCELLATION = "Free cancellation";
export const VIEW_POLICY_DETAILS = "View policy details";
export const CANCELLATION_POLICY = "Cancellation policy";
export const ADDITIONAL_DETAILS = "Additional details";

export const CONTINUE_TEXT = "Continue";
